import {HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {AUTH_TOKEN_V2_REFRESH_TOKEN, AUTH_TOKEN_V2_STORAGE_KEY} from '../auth.guard';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {map, switchMap} from 'rxjs/operators';

@Injectable()
export class JwtTokenInterceptor implements HttpInterceptor {

  constructor(private readonly http: HttpClient) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem(AUTH_TOKEN_V2_STORAGE_KEY);
    const refreshToken = localStorage.getItem(AUTH_TOKEN_V2_REFRESH_TOKEN);

    if (request.url.endsWith('/login')
        || request.url.endsWith('/refresh')
        || request.url.includes('/passwords/askReset')
        || request.url.includes('/passwords/reset/')) {
      return next.handle(request);
    }

    if (!token && !refreshToken) {
      this.logout();
    }

    const isApiCall = request.url.startsWith(environment.apiPath) || request.url.startsWith(environment.apiPathV2);

    if (token && isApiCall) {
      if (this.isTokenExpired(token)) {
        if (!refreshToken || this.isTokenExpired(refreshToken)) {
          this.logout();
          return throwError(() => new Error('Session expired'));
        }

        return this.refreshAccessToken(refreshToken).pipe(
          switchMap(newToken => {
            localStorage.setItem(AUTH_TOKEN_V2_STORAGE_KEY, newToken);
            request = request.clone({ setHeaders: { Authorization: newToken } });
            return next.handle(request);
          }),
          catchError(err => {
            this.logout();
            return throwError(() => err);
          }),
        );
      }

      request = request.clone({
        setHeaders: { Authorization: token },
      });
    }

    return next.handle(request);
  }

  private isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.replace('Bearer ', '').split('.')[1]));
      return (payload.exp * 1000) < Date.now();
    } catch {
      return true;
    }
  }

  private refreshAccessToken(refreshToken: string): Observable<string> {
    return this.http.post<{ accessToken: string }>(environment.apiPathV2 + 'auth/refresh', {
      refreshToken: refreshToken,
    }).pipe(
      map(res => res.accessToken),
    );
  }

  private logout() {
    localStorage.removeItem(AUTH_TOKEN_V2_STORAGE_KEY);
    localStorage.removeItem(AUTH_TOKEN_V2_REFRESH_TOKEN);
    window.location.href = '/login';
  }
}
